import { render, staticRenderFns } from "./OrganizationAddForm.vue?vue&type=template&id=72b2e0fe&"
import script from "./OrganizationAddForm.vue?vue&type=script&lang=js&"
export * from "./OrganizationAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports